import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalHeader, ModalBody, ModalFooter, ModalNext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { WMICButton } from 'wmic-pe-components-platform-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';

import messages from './WMICUIIssuesModal.messages';
import metadata from './WMICUIIssuesModal.metadata.json5';
import paymentPageMessages from '../WMICPaymentPage.messages';

const WMICUIIssuesModal = ({ isOpen, onResolve, uiIssues, isValidationIssues = false }) => {
    const translator = useContext(TranslatorContext);
    const [uiIssuesList, setUiIssuesList] = useState([]);

    const handleClose = () => {
        onResolve();
    };

    useEffect(() => {
        const uiIssuesMessagesList = [];
        _.each(uiIssues, uiIssue => {
            uiIssuesMessagesList.push({ message: uiIssue });
        });
        setUiIssuesList(uiIssuesMessagesList);
    }, []);

    const overrideProps = {
        uiIssuesList: {
            data: uiIssuesList,
        },
        contactUnderwriterText: {
            visible: !isValidationIssues,
        },
    };

    return (
        <ModalNext isOpen={isOpen} onRequestClose={handleClose} status="error">
            <ModalHeader title={translator(paymentPageMessages.error)} status="error" />
            <ModalBody>
                <MetadataContent uiProps={metadata.pageContent} overrideProps={overrideProps} />
            </ModalBody>
            <ModalFooter>
                <div>
                    <WMICButton onClick={handleClose} type="primary">
                        {translator(commonMessages.ok)}
                    </WMICButton>
                </div>
            </ModalFooter>
        </ModalNext>
    );
};

WMICUIIssuesModal.propTypes = {
    uiIssues: PropTypes.arrayOf(PropTypes.string).isRequired,
    isValidationIssues: Boolean,
};

export default WMICUIIssuesModal;
